import moment from 'moment'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import renderers from './customRenderers'

// Note that when adding a language, the language will be automatically
// added to moment, however the locale will not be automatically imported
// for the new language and english will be shown instead.
// Head over to webpack.config.(dev|prod).js and update the momentjs plugin

export const parseTitle = title => <ReactMarkdown renderers={renderers} source={title} />

export const parseContent = (content, updated, locale) => (
    <div className="notification-message">
        <ReactMarkdown key={`content_${name}`} renderers={renderers} source={content} />
        <p key={`timeago_${name}`} className="notification-timeago">
            {moment(updated)
                .locale(locale)
                .fromNow()}
        </p>
    </div>
)



// WEBPACK FOOTER //
// ./src/features/Toaster/markdown/parser.js